<!-- nebylo mozne udelat pres sloty pze boldSearchSubstring(searchVal, formatSearch(option)) v sablone zadratovalo default sablonu z nejakeho duvodu -->
<template>
	<div v-click-outside="onBlur">
		<b-form-tags v-model="tagStrings"
			:id="id"
			ref="formTags"
			:placeholder="placeholder"
			:limit="limit"
			:state="tagState"
			:size="size"
			:disabled="disabled"
			:required="required"
			@focus="onFocus()"
			@ht="onInput"
			:on-remove-tag="onRemoveTag"
			no-feedback
			:no-add-on-enter="onlySelected"
			:no-add-button="onlySelected">
		</b-form-tags>
		<!-- vue b-dropdown nema moznost navesit focus/blur na menu - bez toho neprobehne click -->
		<div class="dropdown b-dropdown">
			<ul role="menu" tabindex="-1"
				:class="`dropdown-menu w-100 ${typeaheadFocused && searchVal ? ' show' : ''}`">
				<li v-if="searchVal && (!items.length||loading)" role="presentation" class="text-center">
					<b-spinner small variant="secondary" label="Načítám" v-if="loading"></b-spinner>
					<span class="b-dropdown-text" v-else>Žádné výsledky</span>
				</li>
				<template v-else>
					<template v-for="(item, index) in items">
						<li role="group-title" class="smaller px-2 py-1" style="background-color: #ebebeb">{{ item.title.toUpperCase() }}</li>
						<li role="presentation" class="small" v-for="option in item.options">
							<div v-if="option.errMsg" class="text-danger px-2">{{ option.errMsg }}</div>
							<button v-else role="menuitem" type="button" class="dropdown-item text-truncate" @click="onTagClick(option)">
								<span v-html="boldSearchString(searchVal, getFormatOption(option))"></span>
							</button>
						</li>
					</template>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
import tagsTypeaheadMixin from '../mixins/tags-typeahead_mixin';
export default {
	mixins: [tagsTypeaheadMixin]
}
</script>